import { Product, ProductVariant } from '@commercetools/platform-sdk';

import { CustomProductKey, findAttributeByName } from '@/lib/product/attributes';

/**
 * The supported custom product keys for the `CustomPDP` view and `customProduct` store.
 */
export type SupportedCustomProductKey = Extract<CustomProductKey, 'Custom Mix' | 'Custom Tray'>;

export const isActive = (variant: ProductVariant) =>
  findAttributeByName(variant.attributes, 'active') === true;

export const isUnpublished = (product: Product) => !product.masterData.published;
